import { render } from "./ProductArchivingDialog.vue?vue&type=template&id=4722cd3d"
import script from "./ProductArchivingDialog.vue?vue&type=script&lang=js"
export * from "./ProductArchivingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__